const wechatAuthorization = 'wechatAuthorization';

// 控制弹出框弹出后禁止页面滚动
const ModalHelper = (function (bodyCls) {
  let scrollTop;

  return {
    afterOpen() {
      scrollTop = document.scrollingElement.scrollTop;
      document.body.classList.add(bodyCls);
      document.body.style.top = -scrollTop + 'px';
    },

    beforeClose() {
      document.body.classList.remove(bodyCls);
      // scrollTop lost after set position:fixed, restore it back.
      document.scrollingElement.scrollTop = scrollTop;
    },
  };
})('modal-open');

// 设置body的class
const setBodyClass = (val) => {
  if (!val) {
    return;
  }

  let _className = document.body.className;

  if (_className.indexOf(val) >= 0) {
    return;
  }

  _className = _className + " " + val;
  document.body.className = _className;
};

// 移除body的class
const removeBodyClass = (val) => {
  if (!val) {
    return;
  }

  let _className = document.body.className;

  if (_className.indexOf(val) == -1) {
    return;
  }

  _className = _className.replace(val, '');
  document.body.className = _className;
};

// 设置html的class
const setHtmlClass = (val) => {
  if (!val) {
    return;
  }

  let _className = document.documentElement.className;

  if (_className.indexOf(val) >= 0) {
    return;
  }

  _className = _className + " " + val;
  document.documentElement.className = _className;
};

// 移除html的class
const removeHtmlClass = (val) => {
  if (!val) {
    return;
  }

  let _className = document.documentElement.className;

  if (_className.indexOf(val) == -1) {
    return;
  }

  _className = _className.replace(val, '');
  document.documentElement.className = _className;
};

// 设置document标题
const setDocumentTitle = (val) => {
  document.title = val;
};

// 跳转到错误界面
const toError = (router, query = {}) => {
  if (!router) {
    return;
  }
  router.push({
    name: 'error',
    query: query,
  });
};

// 滚动条滚动监听
const scrollControl = (val) => {
  if (val) {
    ModalHelper.afterOpen();
  } else {
    ModalHelper.beforeClose();
  }
};

// 获取openid
const redirectToGetOpenId = (router, href) => {
  if (!href) {
    href = window.location.href;
  }

  const openid = GetQueryString(href, 'openid') || GetQueryString(href, 'openId');

  if (openid) {
    return openid;
  }

  const appid = GetQueryString(href, 'appid') || GetQueryString(href, 'appId');

  if (!appid) {
    return '';
  }

  const location = {
    appid,
    path: encodeURIComponent(href),
  };

  router.replace({
    name: wechatAuthorization,
    query: location,
  });
};

// 获取url参数
function GetQueryString(href, name) {
  const search = href.substr(href.indexOf('?'));

  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = search.substr(1).match(reg); //search,查询？后面的参数，并匹配正则

  if (r != null) return unescape(r[2]);
  return null;
}

// 拨打手机号
const callphone = (tel) => {
  window.location.href = 'tel:' + tel;
};

// 微信分享
const share = (data) => {
  window.wx.onMenuShareAppMessage(data);
  window.wx.onMenuShareTimeline(data);
  window.wx.onMenuShareQQ(data);
  window.wx.onMenuShareWeibo(data);
};

// 设置timeType
const setTimeTypeMark = (t) => {
  sessionStorage.setItem('zm-time-type', t);
};

export default {
  setBodyClass,
  removeBodyClass,
  setHtmlClass,
  removeHtmlClass,
  setDocumentTitle,
  scrollControl,
  toError,
  redirectToGetOpenId,
  callphone,
  share,
  setTimeTypeMark,
};
